import { Directive, HostListener, Input } from '@angular/core';
import { TEClickProductItem } from '@x/common/tracking/event-models/click.events';
import { TrackingService } from '@x/common/tracking/tracking.service';
import { IProductItem } from '@x/ecommerce-shop/app/core/product/types/product-item';

@Directive({
  selector: '[xTrackingProductClick]',
  standalone: true,
})
export class TrackingProductClickDirective {
  @Input({
    alias: 'xTrackingProductClick',
    required: true,
  })
  productItem: IProductItem;

  @HostListener('click')
  public onClick(): void {
    if (!this.productItem) throw new Error('Product item is required');

    this.analyticsService.sendEvent(
      new TEClickProductItem(this.analyticsService.routeOrigin, {
        productItem: { ...this.productItem },
      }),
    );
  }

  constructor(private analyticsService: TrackingService) {}
}
